import React, { useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { ModalConfirmationProps } from '../../../types/components/modal'
import { ModalConfirmationStyle, WrapperButtonsModal, ButtonModal } from './style'

export const ModalConfirmation: ModalConfirmationProps = ({
  onSubmit,
  setPreConfirmed,
  email,
  phone,
  name,
  cpf,
  cnpj
}) => {
  const [isValidateCaptcha, setIsValidateCaptcha] = useState(false)
  const validateCaptcha = () => {
    setIsValidateCaptcha(true)
  }

  const expiredCaptcha = () => {
    setIsValidateCaptcha(false)
  }
  return (
    <ModalConfirmationStyle>
      <section>
        <h3>Verifique os seus dados antes de enviar!</h3>
        <p>Nome completo: {name}</p>
        <p>CPF: {cpf}</p>
        <p>E-mail: {email}</p>
        <p>Celular: +55 {phone}</p>
        {cnpj.length > 0 && <p>CNPJ: {cnpj}</p>}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
          onChange={validateCaptcha}
          onExpired={expiredCaptcha}
        />
        <WrapperButtonsModal>
          <ButtonModal typeButton={1} onClick={() => setPreConfirmed(false)}>
            Editar dados
          </ButtonModal>
          <ButtonModal typeButton={2} onClick={onSubmit} disabled={!isValidateCaptcha}>
            Enviar
          </ButtonModal>
        </WrapperButtonsModal>
      </section>
    </ModalConfirmationStyle>
  )
}
